module.exports = __webpack_public_path__ + "img/material-vector-sample.3e6aa82b.svg";